const GateConstants = {
  validGateHeaders: {
    'Depot Ref Id*': 'depot_ref_id',
    'Depot Name*': 'depot_name',
    'Gate Ref Id*': 'reference_id',
    'Gate Name*': 'name',
    'Type': 'gate_type',
    'City*': 'city',
    'State*': 'state',
    'Pin Code*': 'pincode',
    'Region*': 'region',
    'Address*': 'address',
    Lat: 'lat',
    Long: 'long',
    'Special Tax Rebate': 'special_tax_rebate',
    'Legal Entity': 'legal_entity',
    Docks: 'docks',
    'Short Code': 'short_code',
    'Exclude trucks from Destinations': 'exclude_trucks',
    'Exclude trucks from Sources': 'exclude_trucks_sources',
    'De-couple deliveries': 'delivery_do_not_combine',
    'Combine delivery with other depots': 'combine',
    Category: 'category',
    'Dispatch Throughput - Weight (KG)': 'dispatch_throughput_weight',
    'Dispatch Throughput - Volume (CFT)': 'dispatch_throughput_volume',
    'Dispatch Throughput - No of Trucks': 'dispatch_throughput_trucks',
    'Unloading Throughput - Weight (KG)': 'unloading_throughput_weight',
    'Unloading Throughput - Volume (CFT)': 'unloading_throughput_volume',
    'Unloading Throughput - No of Trucks': 'unloading_throughput_trucks',
    'Courier Ref Id' : 'courier_ref_id',
    'Manager email ids': 'manager_email_ids',
  },
  nonMandatoryGateHeaders: {
    'Gate Group': 'gate_group',
  }
};

const VirtualLocationsErrors = {
  invalidType: 'Virtual location must be a string',
};

const GateType = {
  default : 1,
  virtual : 2,
  store : 3,
}

module.exports = { GateConstants, VirtualLocationsErrors, GateType };
